
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white min-h-screen flex items-center"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/f26cf462079a790c7f218f28a5fffb7d.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-blue-900/70"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="w-full">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Transform Your Business with 
              <span className="text-blue-300"> Expert IT Solutions</span>
            </h1>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Partner with TechServe for comprehensive IT consulting, cloud migration, cybersecurity, and digital transformation solutions that drive innovation and accelerate your business growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button variant="primary" size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                <i className="ri-rocket-line mr-2"></i>
                Get Free Consultation
              </Button>
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-900">
                <i className="ri-play-circle-line mr-2"></i>
                View Our Services
              </Button>
            </div>
            
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-300">500+</div>
                <div className="text-sm text-blue-100 mt-1">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-300">98%</div>
                <div className="text-sm text-blue-100 mt-1">Client Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-300">15+</div>
                <div className="text-sm text-blue-100 mt-1">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
